/**
 * Exam Convocation Types
 * Types for periodic exam convocation feature
 */

import { ROTULO_DO_NIVEL, type NivelDeAplicacao } from './nivelDeAplicacao';

export type ConvocationStatus = 'overdue' | 'expiring' | 'ok';

export interface ConvocationItem {
  employeeId: number;
  employeeName: string;
  departmentId: number | null;
  departmentName: string | null;
  occupationId: number | null;
  occupationName: string | null;
  examId: number;
  examName: string;
  applicationLevel: NivelDeAplicacao;
  periodicityMonths: number;
  lastCompletedDate: string | null;
  nextDueDate: string | null;
  status: ConvocationStatus;
  daysOverdue: number;
  companyId: number;
  examEmployeeApplicationId: number | null;
}

export interface ConvocationSummary {
  totalOverdue: number;
  totalExpiring: number;
  totalOk: number;
  totalEmployeesAffected: number;
}

export interface ConvocationFilters {
  status?: ConvocationStatus;
  departmentId?: number;
  occupationId?: number;
  employeeId?: number;
  search?: string;
  expiringDays?: number;
}

export interface ConvocationListParams extends ConvocationFilters {
  companyId: number;
  page?: number;
  limit?: number;
}

export interface ConvocationListResponse {
  items: ConvocationItem[];
  total: number;
  summary: ConvocationSummary;
  page: number;
  totalPages: number;
}

export const ConvocationStatusConfig: Record<ConvocationStatus, { label: string; color: 'error' | 'warning' | 'success' }> = {
  overdue: { label: 'Vencido', color: 'error' },
  expiring: { label: 'Vencendo', color: 'warning' },
  ok: { label: 'Em dia', color: 'success' },
};

export const ApplicationLevelLabels: Record<NivelDeAplicacao, string> = ROTULO_DO_NIVEL;
